import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import GithubSecretScanMappingForm from './GithubSecretScanMappingForm';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

const GithubSecretScanCredentialsForm = forwardRef((props, ref) => {
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => [
        ...(featureFlags.ENABLE_GHAS_FOR_ENTERPRISE ? [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator],
        }] : []),
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ],[featureFlags.ENABLE_GHAS_FOR_ENTERPRISE]);
    return (
        <GenericPullCredentialsForm 
         {...props} 
         ref={ref}
         fields={fields}
         toolDisplayName="GitHub Secret Scan"
         versionField={false} 
         initialValue={{ apiEndpoint: 'https://api.github.com' }}
         MappingForm={GithubSecretScanMappingForm}
          />
    )
});

export default GithubSecretScanCredentialsForm;